<template>
  <div class="hello">
        <div class="carousel-wrap height">
<!--          <img src="../assets/untitled-99.png" alt="" style="width:40%;">-->
           <div class="col-xs-12 col-sm-12 col-md-6 col-lg-5" style="position: relative;">
              <img src="../assets/未标题-777.png" class="left-img" alt="">

            <!-- <div class="home-banner">
              <div class="home-banner-hotel">
                <div class="home-banner-hotel-title">酒店</div>
                <div class="home-banner-hotel-list">
                  <span>入住</span>
                  <span>下单</span>
                  <span>评价</span>
                  <span>结算</span>
                </div>
              </div>
              <div class="home-banner-hotel">
                <div class="home-banner-hotel-title">服务机构</div>
                <div class="home-banner-hotel-list">
                  <span>入驻</span>
                  <span>接单</span>
                  <span>培训</span>
                  <span>结算</span>
                </div>
              </div>
              <div class="home-banner-clear">
                <div class="home-banner-hotel-title">保洁人员</div>
                <div class="home-banner-hotel-list">
                  <span>注册</span>
                  <span>接单</span>
                  <span>培训</span>
                  <span>结算</span>
                </div>
              </div>
            </div>
            <div class="home-banner-img center">
              <img src="../assets/untitled-99.png" alt="">
            </div>
            <img class="home-banner-img-mark1" src="../assets/untitled-11.png" alt="">
            <img class="home-banner-img-mark2" src="../assets/untitled-12.png" alt=""> -->

          </div>
          <div class="carousel-text col-xs-12 col-sm-12 col-md-6 col-lg-5">
              <!-- <h1>全国专业化、效率化、系统化酒店外包人力资源服务平台，值得你们的信赖！</h1> -->
            <p>全国专业化、效率化、系统化酒店外包</p>
            <p style="color: #ffffff">人力资源服务平台，值得您的信赖！</p>
            <div class="home-banner-img-content">
              <!-- <span>租户管理</span>
              <span>业务管理</span>
              <span>绩效管理</span>
              <span>培训管理</span>
              <span>对账管理</span>
              <span>评价管理</span> -->
              <img src="../assets/未标题-98.png" alt="" style="width:60%;">
            </div>
            <div class="carousel-text-ul-wrap">
              <img class="carousel-text-ul-QR" src="../assets/1571208580.png" alt="">
              <div class="carousel-text-ul-text">APP下载</div>
            </div>
            <div class="carousel-text-ul-wrap" @click="toHotel()">
              <img class="carousel-text-ul-QR" src="../assets/untitled-20.png" alt=""   style="cursor: pointer">
              <div class="carousel-text-ul-text"><span  style="cursor: pointer">酒店</span></div>
            </div>
            <div class="carousel-text-ul-wrap" @click="toKeeperauth()">
              <img class="carousel-text-ul-QR" src="../assets/untitled-21.png"  style="cursor: pointer" alt="">
              <div class="carousel-text-ul-text"><span  style="cursor: pointer">人力服务公司</span></div>
            </div>
           <!-- <div @click="toHotel()">
              <img src="../assets/untitled-20.png" alt="">
              <p>酒店</p>
            </div>
            <div @click="toKeeperauth()">
              <img src="../assets/untitled-21.png" alt="">
              <p>人力服务公司</p>
            </div>-->
          </div>
        </div>

  </div>
</template>

<script>
    export default {
        name: 'AboutHome',
        data() {
            return {
                height: 0,
                cooperateList: [
                    {cooperateUrl: require('../assets/hotel1.png')},
                    {cooperateUrl: require('../assets/hotel2.png')},
                    {cooperateUrl: require('../assets/hotel3.png')},
                    {cooperateUrl: require('../assets/logo.png')}
                ]
            }
        },
        mounted () {
          this.height = window.innerHeight - 60;
        },
      methods:{
        toHotel(){
          // this.$router.push({ path:'http://hk.finewe.com.cn/#/hotelauth'});
          window.location.href = 'https://admin.weixinbang.com.cn/#/hotelauth';
        },
        toKeeperauth(){
          window.location.href = 'https://admin.weixinbang.com.cn/#/keeperauth';
        },
      }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../assets/scss/index.scss';
@media screen and (min-width:0px) and (max-width:900px){
    // body {background-color:#f5f5f5;}
    .height{
      height: 800px;
    }
  }
  @media screen and (min-width:900px) and (max-width:1200px){
    // body {background-color:#f5f5f5;}
    .height{
      height: 800px;
    }
  }
  @media screen and (min-width:600px) and (max-width:900px){
    // body {background-color:#f5f5f5;}
    .height{
      height: 870px;
    }
  }
  @media screen and (min-width: 1200px) {
    .height{
      height: calc(100vh - 60px);
    }
  }
  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    /*line-height: 400px;*/
    margin: 0;
  }
  @media screen and (max-width: 768px) {
      .carousel-wrap{
        // height: 730px;
        background: url('../assets/banner-1.png')no-repeat;
        background-size: 100% 100%;
        // padding-top: 50px;
        display: flex;
        // justify-content: center;
        // align-items: center;
        // display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
      }
      .carousel-text {
        margin-top:50px;
      }
    .carousel-text-ul-wrap{
      // padding: 20px;
      width: 33.3%;
      @include px2rem(padding, 20);
      .carousel-text-ul-QR{
        @include px2rem(width, 100);
        @include px2rem(height, 100);
      }
      .carousel-text-ul-text{
        color: #fff;
        @include px2rem(font-size, 24);
      }
    }
    .left-img{
      width: 70%;
      margin-top: 20px;
    }
  }
  @media screen and (min-width: 768px) {
      .carousel-wrap{
        // height: calc(100vh - 60px);
        width: 100%;
        background: url('../assets/banner-1.png')no-repeat;
        background-size: 100% 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    .carousel-text-ul-wrap{
      // padding: 20px;
      width: 33.3%;
      @include px2rem(padding, 20);
      .carousel-text-ul-QR{
        @include px2rem(width, 100);
        @include px2rem(height, 100);
      }
      .carousel-text-ul-text{
        color: #fff;
        @include px2rem(font-size, 24);
      }
    }
    .left-img{
      width: 70%;
      margin-top: 20px;
    }
  }
  .carousel-wrap {

  }

  .carousel-cooperate-list > img {
    width: 25%;
    height: 120px;
    margin: 10px 20px;
  }

  .carousel-graphic {
    width: 35%;
    height: 400px;
    float: left;
    margin-left: 50px;
  }

  .carousel-text {
    // @include px2rem(width, 600);
    @include px2rem(height, 500);
    @include flex(center);
    p{
      display: block;
      width: 100%;
      // font-size: 20px;
      @include px2rem(font-size, 24);
      font-weight: 600;
      color: #ffdd11;
    }
  }

  .carousel-text > h1 {
    line-height: 50px;
  }

  .carousel-text > p {
    line-height: 30px;
  }

  .carousel-code {
    width: 100%;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-items: center;
    flex-wrap: wrap;
    justify-content: center;
  }

  .carousel-code img {
    @include px2rem(width, 150);
    @include px2rem(height, 150);

    // width: 150px;
    // height: 150px;
  }

  .carousel-cooperate > h2 {
    line-height: 60px;
  }
  .carousel-text-ul{
    // width: 500px;
    @include px2rem(width, 500);
    li{
      display: block;
      @include px2rem(width, 500);
      @include px2rem(font-size, 20);
      // width: 500px;
      text-align: left;
      color:#fff;
      padding: 10px 10px;
      border: 1px dotted #fff;
      border-radius: 5px;
      margin-top: 20px;
      box-sizing: border-box;
      // i{
      //   border-radius: 50%;
      //   background: #fff;
      //   display: block;
      //   width: 10px;
      //   height: 10px;
      //   float: left;
      // }
    }
  }
  .home-banner{
    // position: absolute;
    // @include px2rem(left, 250);
    // @include px2rem(top, 150);
    @include px2rem(width, 700);
    // left: 50px;
    // top: 150px;
    // width: 700px;
    @include flex(space-between)
  }
  .home-banner-hotel{
    @include px2rem(width, 150);
    @include px2rem(height, 100);

    // width: 150px;
    // height: 100px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-items: center;
    flex-wrap: wrap;
    justify-content: center;
    .home-banner-hotel-title{
      @include px2rem(width, 100);
      @include px2rem(height, 30);
      @include px2rem(line-height, 32);
      @include px2rem(font-size, 20);

      // width: 75px;
      // height: 25px;
      // line-height: 25px;
      // font-size: 16px;
      color:#fff;
      border-radius: 5px;
      background: #ff6d1d;
    }
    .home-banner-hotel-list{
      @include px2rem(width, 150);
      @include px2rem(height, 100);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-items: center;
      flex-wrap: wrap;
      justify-content: space-around;
      span{
        @include px2rem(width, 50);
        @include px2rem(height, 30);
        @include px2rem(line-height, 32);
        @include px2rem(font-size, 20);
        // @include px2rem(line-height, 25);
        display: block;
        float: left;
        color:#fff;
        border: 1px dotted #fff;
        // font-size: 16px;
        border-radius: 5px;
      }
    }
  }
  .home-banner-clear{
    @include px2rem(width, 150);
    @include px2rem(height, 100);
    position: absolute;
    bottom:0;
    @include px2rem(bottom, 100);
    @include px2rem(left, 620);

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-items: center;
    flex-wrap: wrap;
    justify-content: center;
    .home-banner-hotel-title{
      @include px2rem(width, 100);
      @include px2rem(height, 30);
      @include px2rem(line-height, 32);
      @include px2rem(font-size, 20);
      color:#fff;
      border-radius: 5px;
      background: #ff9f41;
    }
    .home-banner-hotel-list{
      @include px2rem(width, 150);
      @include px2rem(height, 100);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-items: center;
      flex-wrap: wrap;
      justify-content: space-around;
      span{
        @include px2rem(width, 50);
        @include px2rem(height, 30);
        @include px2rem(line-height, 32);
        @include px2rem(font-size, 20);
        display: block;
        float: left;
        color:#fff;
        border: 1px dotted #fff;
        border-radius: 5px;
      }
    }
  }
  .home-banner-img{
    // position: absolute;
    // @include px2rem(width, 500);
    // @include px2rem(left, 350);
    // @include px2rem(top, 250);
    // @include px2rem(width, 500);

    // width: 500px;
    // left: 250px;
    // top: 250px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-items: center;
    flex-wrap: wrap;
    justify-content: center;
    img{
      @include px2rem(width, 500);
      @include px2rem(height, 500);
      // width: 300px;
      // height: 300px;
    }
  }
.home-banner-img-content{
  // width: 380px;
  // @include px2rem(width, 580);
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-items: center;
  flex-wrap: wrap;
  justify-content: space-around;
  @include px2rem(margin-bottom, 20);
  span{
    display: block;
    // @include px2rem(width, 120);
    @include px2rem(height, 30);
    @include px2rem(line-height, 32);
    @include px2rem(font-size, 20);
    @include px2rem(margin-right, 30);
    // @include px2rem(margin-left, 30);
    @include px2rem(margin-top, 20);
    margin-left: 30px;
    width: 120px;
    float: left;
    color:#ff6d1d;
    background: rgba($color: #fff, $alpha: 0.7);
    // font-size: 16px;
    border-radius: 5px;
    // margin-top: 20px;
  }
}
  .home-banner-img-mark1{
    // @include px2rem(width, 20);
    @include px2rem(width, 80);
    position: absolute;
    @include px2rem(top, 150);
    @include px2rem(left, 30);
  }
  .home-banner-img-mark2{
    // @include px2rem(width, 30);
    @include px2rem(width, 60);
    position: absolute;
    @include px2rem(top, 370);
    @include px2rem(left, 560);
  }
  .carousel-text-ul-wrap{
    // padding: 20px;
    @include px2rem(padding, 20);
    .carousel-text-ul-QR{
      @include px2rem(width, 150);
      @include px2rem(height, 150);
    }
    .carousel-text-ul-text{
      color: #fff;
      @include px2rem(font-size, 20);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AboutHome.vue